export const PAYMENT_KEYS = {
  mBuyoutBundleOneTimePayment: ["/buyout_bundles/one_time_payment/"],
  mInvoiceBatchPayment: ["/invoices/batch_pay/"],
  mPackageEmailSubscribe: ["/packages/subscribe_email/"],
  mPackageListSubscribe: ["/packages/subscribe/"],
  mPackageSubscribe: (packageId: number) => [`/packages/${packageId}/subscribe/`],
  mPackageSubscription: (subscriptionId: number) => [`/package_subscriptions/${subscriptionId}/`],
  mPackageSubscriptionCancel: ["/package_subscriptions/cancel/"],
  mPackageSubscriptionList: ["/package_subscriptions/"],
  mPackageSubscriptionUpgrade: ["/package_subscriptions/upgrade/"],
  qBundleBuyoutInvoiceList: (params?: string) => [`/invoices/bundle_buyout_invoices/?${params}`],
  qBundleBuyoutInvoiceListPdfExport: (params?: string) => [
    `/invoices/bundle_buyout_invoices/?pdf_export=True&${params}`,
  ],
  qBuyoutBundleList: (params?: string) => [`/buyout_bundles/?${params}`],
  qCreditNotes: (creditNoteId: number) => [`/credit_notes/${creditNoteId}/pdf/`],
  qCreditNoteSummary: (invoiceId: number) => [`/invoices/${invoiceId}/summary_credit_note_pdf/`],
  qInvoiceCampaignApplications: (id: number) => [`/invoices/${id}/campaign_applications/`],
  qInvoiceManagement: (params?: string) => [`/invoices/invoice_management/?${params}`],
  qMediaPurchaseInvoiceList: (params?: string) => [`/media_purchase/?${params}`],
  qMediaPurchaseInvoiceListPdfExport: (params?: string) => [`/media_purchase/?pdf_export=True&${params}`],
  qPackageList: (params?: string) => [`/packages/?${params}`],
  qRegularInvoiceList: (params?: string) => [`/invoices/?${params}`],
  qRegularInvoiceListPdfExport: (params?: string) => [`/invoices/?pdf_export=True&${params}`],
} as const;
